export const WhyThisItems = [
  {
    id: 1,
    text: "15 lat doświadczenia",
    subtext:
      "Jesteśmy zespołem doświadczonych specjalistów, którzy zdobywali wiedzę przez 15 lat praktyki.",
    imgSrc: "/icons/hourglass.svg",
    content: [
      {
        title: "Solidność na Pierwszym Miejscu",
        text: "Z upływem lat nie tylko doskonalimy nasze umiejętności, ale także zyskujemy zaufanie klientów poprzez solidne wykonanie każdej usługi. To solidne fundamenty, na których budujemy naszą reputację.",
      },
      {
        title: "Dostosowane Rozwiązania",
        text: "Nasze doświadczenie to nie tylko lata praktyki, ale także nauka z różnych projektów. Potrafimy dostosować się do indywidualnych potrzeb klientów, oferując kompleksowe, spersonalizowane rozwiązania.",
      },

      {
        title: "Zaufanie Klientów",
        text: "15 lat to nie tylko liczba, to również zaufanie naszych klientów, którzy zawsze wracają do nas z nowymi projektami. To dla nas największa nagroda i potwierdzenie, że nasze podejście do pracy przynosi satysfakcję.",
      },
    ],
  },

  {
    id: 2,
    text: "Nowoczesny sprzęt",
    subtext:
      "Inwestujemy w najnowsze technologie, aby nasze usługi były jeszcze lepsze.",
    imgSrc: "/icons/wkretarka.svg",
    content: [
      {
        title: "Efektywność w Działaniu",
        text: "Nowoczesny sprzęt nie tylko podnosi jakość naszych usług, ale również sprawia, że prace przebiegają efektywnie. Dzięki temu możemy dostarczyć kompleksowe wykończenia wnętrz w krótszym czasie, nie rezygnując przy tym z najwyższej jakości.",
      },
      {
        title: "Innowacyjne Materiały",
        text: "Współpracujemy z nowoczesnymi materiałami, które w połączeniu z nowatorskim sprzętem pozwalają nam na kreowanie unikalnych, nowoczesnych wnętrz. Kładziemy nacisk na zrównoważone i innowacyjne rozwiązania, które spełniają oczekiwania nawet najbardziej wymagających klientów.",
      },
      {
        title: "Oszczędność Bez Kompromisów",
        text: "Nowoczesny sprzęt nie tylko gwarantuje doskonałe efekty, ale także pozwala nam na optymalne wykorzystanie materiałów i zasobów. Dzięki temu oferujemy konkurencyjne ceny bez kompromisów w jakości.",
      },
    ],
  },
  {
    id: 3,
    text: "Terminowość",
    subtext:
      "Twój czas jest dla nas kluczowy. Dzięki starannej organizacji i otwartej komunikacji, efekty zgodnie z harmonogramem.",
    imgSrc: "/icons/calendar.svg",
    content: [
      {
        title: "Zobowiązanie do Harmonogramu",
        text: "Nasza firma pracuje z pełnym zobowiązaniem do ustalonego harmonogramu. Zanim rozpoczniemy projekt, szczegółowo planujemy każdy etap, zapewniając, że prace zostaną ukończone zgodnie z oczekiwaniami.",
      },
      {
        title: "Transparentna Komunikacja",
        text: "Terminowość opiera się na jasnej i regularnej komunikacji. Zapewniamy naszym klientom pełną przejrzystość co do postępu prac, informując o ewentualnych zmianach w harmonogramie oraz dostosowaniach, aby uniknąć niespodzianek.",
      },
      {
        title: "Dostosowanie do Twoich Terminów",
        text: "Jesteśmy elastyczni i dostosowujemy się do Twoich potrzeb. Szanujemy Twój czas, dlatego pracujemy nad projektem tak, abyś mógł cieszyć się efektami końcowymi dokładnie wtedy, kiedy tego oczekujesz.",
      },
    ],
  },
  {
    id: 4,
    text: "Wsparcie w doborze materiałów",
    subtext:
      "Nie tylko wykonujemy, ale i doradzamy. Dostosujemy materiały do Twoich potrzeb.",
    imgSrc: "/icons/friendly.svg",
    content: [
      {
        title: "Dostosowanie do Indywidualnych Preferencji",
        text: "Wspólnie z Tobą analizujemy Twoje oczekiwania, preferencje i styl, aby dobrać materiały, które doskonale oddadzą charakter Twojego projektu. Chcemy, abyś był pewien, że każdy detal spełnia Twoje oczekiwania.",
      },
      {
        title: "Budżetowe Optymalizacje",
        text: "Pomagamy w dostosowaniu wyboru materiałów do Twojego budżetu, szukając równowagi między jakością a kosztami. Dzięki temu możemy zaproponować rozwiązania, które są zarówno estetyczne, jak i przystępne finansowo.",
      },
      {
        title: "Przyjazne Doradztwo",
        text: "Jesteśmy gotowi odpowiedzieć na wszelkie pytania i udzielić profesjonalnych porad dotyczących materiałów. Nasze doradztwo ma na celu sprawić, że proces wyboru będzie dla Ciebie łatwy i satysfakcjonujący.",
      },
    ],
  },
  {
    id: 5,
    imgSrc: "/icons/money.svg",
    text: "Atrakcyjne ceny",
    subtext:
      "Jakość nie musi kosztować fortuny. Oferujemy atrakcyjne ceny bez kompromisów w jakości.",
    content: [
      {
        title: "Transparentność Kosztów",
        text: "Jesteśmy zwolennikami transparentności. Przed rozpoczęciem projektu przedstawiamy jasny kosztorys, abyś mógł z góry znać wszystkie koszty związane z naszymi usługami. Bez ukrytych opłat i nieprzyjemnych niespodzianek.",
      },
      {
        title: "Dostosowanie do Budżetu",
        text: "Rozumiemy, że każdy projekt ma swoje ograniczenia budżetowe. Nasza elastyczność pozwala nam dostosować ofertę do Twoich możliwości finansowych, nie rezygnując przy tym z jakości.",
      },
      {
        title: "Optymalne Wykorzystanie Zasobów",
        text: "Posiadamy sprawdzone metody pracy i efektywne procesy, co pozwala nam optymalnie wykorzystywać zasoby i utrzymywać atrakcyjne ceny bez wpływu na jakość.",
      },
    ],
  },
];
